import { Component } from "react";
import { IoSettingsOutline } from "react-icons/io5";
import Window from "../ui/Window";
import Unidades from "./ajustes/Unidades";
import { Stack } from "@mui/material";
import Depositos from "./ajustes/Depositos";
import Settings from "./ajustes/Settings";
import Cookies from "universal-cookie";
import { Navigate } from "react-router-dom";
import Metas from "./ajustes/Metas";

export default class Ajustes extends Component {

    constructor(props) {
        super(props);
        let cookies = new Cookies();
        this.user = cookies.get('user');
        this.state = {
            loading: false,
            toHome: !this.user.isAdmin
        }
    }

    render() {
        return (
            <>
                {this.user.isAdmin &&
                    <Window full title="Ajustes" icon={IoSettingsOutline}>
                        <Stack p={2} gap={1} sx={{ overflowY: 'scroll' }} pr={1}>
                            <Settings />
                            <Unidades />
                            <Depositos />
                            <Metas />
                        </Stack>
                    </Window>
                }
                {this.state.toHome && <Navigate to='/' />}
            </>
        );
    }
}
